import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getWord } from "../../utils/functions";
import store from "../../store/store";
import * as actionTypes from "../../store/actions";

const Dashboard = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  const handleLogout = () => {
    store.dispatch({
      type: actionTypes.LOGOUT,
      payload: { userdata: "" },
    });
    navigate("/", { replace: true });
  };
  return user.isLoggedIn ? (
    <>
      <div className="col-md-9">
        <div className="grid-layout wrapper-shop">
          <div className="tf-login-content">
            <h6>
              {getWord("Hello")} {user.userdata.fname} {user.userdata.lname}{" "}
              (not{" "}
              <span>
                {user.userdata.fname} {user.userdata.lname} ?
              </span>
              <a onClick={handleLogout}>{getWord("Logout")}</a>)
            </h6>
          </div>
          <p>
            {getWord(
              "From your account dashboard you can view your recent orders, manage your shipping and billing addresses, and edit your password and account details"
            )}
          </p>
          <a
            href="#filterShop"
            data-bs-toggle="offcanvas"
            aria-controls="offcanvasLeft"
            className="tf-lg-hidden"
          >
            <button className="tf-btn radius-3 btn-fill btn-icon animate-hover-btn justify-content-center mt-5">
              {getWord("Click for more option")}
            </button>
          </a>
        </div>
      </div>
    </>
  ) : (
    ""
  );
};

export default Dashboard;
